import { common } from '@tencent/ceiba-base-components';
const BB_VIA_LIST = [
  'qqfcmzs',
  'zhcfm',
  'cfzs',
  'zhcfhd',
  'dnfzs',
  'nzzs',
  'qqfcpczs',
  'xwxlt',
  'xwsdzs',
  'tdzs',
  'txyxsq',
  'zs',
];
/**
 * 根据不同业务使用不同的APP判断逻辑
 * @returns 是否在APP内打开
 */
export const isAPP = function () {
  switch (currentAstName()) {
    case 'TGCLUB': {
      return /tgclub/i.test(window.navigator.userAgent);
    }
    case 'BB': {
      return !!window?.navigator.userAgent.match(/gamehelper/i);
    }
    case 'SPARK': {
      return /com\.tencent\.gamecommunity/.test(window.navigator.userAgent);
    }
    default:
      break;
  }
  return false;
};

/**
 * 根据域名和via参数判断业务
 * @returns 业务名称
 */
export const currentAstName = function () {
  const currentHost = window?.location.host;
  let astName = '';
  switch (currentHost) {
    case 'act.xinyue.qq.com': {
      // 由于助手bb业务共用心悦域名,需要额外判断url参数
      const via = common.tool.getQueryparams('via') || '';
      let includeBB = false;
      BB_VIA_LIST.forEach((v) => {
        if (via.startsWith(v)) {
          includeBB = true;
        }
      });
      const includeSpark = via.startsWith('spark'); // 闪现
      const includeSupercore = via.startsWith('svip'); // 超核
      const includeGbot = via.startsWith('gbot'); // 知己
      if (includeSpark) {
        astName = 'SPARK';
      } else if (includeSupercore) {
        astName = 'SUPERCORE';
      } else if (includeGbot) {
        astName = 'GBOT';
      } else if (includeBB) {
        astName = 'BB';
      } else {
        astName = 'TGCLUB';
      }
      break;
    }
    case 'act.supercore.qq.com': {
      astName = 'SUPERCORE';
      break;
    }
    case 'act.gbot.qq.com': {
      astName = 'GBOT';
      break;
    }
    default:
      astName = 'TGCLUB';
      break;
  }
  return astName;
};

export default {
  isAPP,
  currentAstName,
};
